
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { _getURL } from "@/api/index";
import _ from 'lodash';
import { HeaderBackTitle } from '../components/common/header';
import { Footer } from '../components/common/footer';
import Image from 'next/image';
import Link from 'next/link';
import { AllMeta } from '@/components/common/meta';
import Head from "next/head";
import { MyBody } from '../components/body/body';
import { CustomLink } from '../components/app/customLink';

export default function Index(props) {
    const { t, device, session } = props;

    return (
        <>
            <AllMeta
                title={t('aboutUsPage_meta_title')}
                description={t('aboutUsPage_meta_description')}
                keyword={t('aboutUsPage_meta_keyword')}
            />
            <Head><title>{t('aboutUsPage_title')}</title></Head>
            <MyBody
                t={t}
                headerComponent={
                    <HeaderBackTitle
                        title={t('about_us')} 
                        showSearch={false}
                        t={t}
                    />
                }
            >
                <Image 
                    src="/assets/images/about_us_image.jpeg"
                    width={'1000px'}
                    height={'636px'}
                    alt="about_us"
                />
                <div className='containerPadding about_us_container_text'>
                    <p className='fontSize_14'>
                        <CustomLink href={'/'}><span className='fontSize_14 fontColor_red fontWeight_semiBold cursorPointer'>KeyAuto.my</span></CustomLink> 不只是一个马来西亚网路媒体，而是用不同形貌与读者一起掌握汽车脉动。 本站将提供全面及时的汽车资讯，主要频道包括国际与本地新闻、新车介绍、试驾评测、专题报道、新车价格、技术规格、配备、优惠、图库和搜索等一站式资讯。 KeyAuto.my 编辑群致力于提供最新、最夯且全面的汽车资讯，凭借专业的视角及对汽车行业的热爱，带领读者去体会：汽车不只是一种交通工具，对不同的消费者而言，汽车是承载不同意义的生活空间。
                    </p>
                </div>
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <AllMeta
    //             title={t('aboutUsPage_meta_title')}
    //             description={t('aboutUsPage_meta_description')}
    //             keyword={t('aboutUsPage_meta_keyword')}
    //         />
    //         <Head><title>{t('aboutUsPage_title')}</title></Head>
    //         <div className='bodyContainer'>
    //             <div className='contentContainer'>
    //                 <HeaderBackTitle
    //                     title={t('about_us')} 
    //                     showSearch={false}
    //                     t={t}
    //                 />
    //                 <Image 
    //                     src="/assets/images/about_us_image.jpeg"
    //                     width={'1000px'}
    //                     height={'636px'}
    //                     alt="about_us"
    //                 />
    //                 <div className='containerPadding about_us_container_text'>
    //                     <p className='fontSize_14'>
    //                         <Link href={'/'}><span className='fontSize_14 fontColor_red fontWeight_semiBold cursorPointer'>KeyAuto.my</span></Link> 不只是一个马来西亚网路媒体，而是用不同形貌与读者一起掌握汽车脉动。 本站将提供全面及时的汽车资讯，主要频道包括国际与本地新闻、新车介绍、试驾评测、专题报道、新车价格、技术规格、配备、优惠、图库和搜索等一站式资讯。 KeyAuto.my 编辑群致力于提供最新、最夯且全面的汽车资讯，凭借专业的视角及对汽车行业的热爱，带领读者去体会：汽车不只是一种交通工具，对不同的消费者而言，汽车是承载不同意义的生活空间。
    //                     </p>
    //                 </div>
    //                 <Footer t={t} />
    //             </div>
    //         </div>
    //     </>
    // )
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale, ['common'])),
        },
    };
}